import { FORGET_PASSWORD } from "../configs/routes";
import api from "./api";

export const forgotPassword = (data) =>
    new Promise((resolve, reject) => {
        api
            .post(FORGET_PASSWORD, data)
            .then((response) => resolve(response.data))
            .catch((err) => {
                reject(err.response?.data?.errors?.non_field_errors?.[0] || err.response?.data?.message || "Something went wrong");
            });
    });
